<template>
	<div class="pagedraw">
		<div :class="[isMobile ? 'draw-wrap':'draw-wrap-pc']">
			<a v-if="!isMobile" class="closepop" @click="closeConfirm"></a>
			<TopNav
				:title="text"
				:isShowWhy="false">
			</TopNav>
			<login class="login2"
				@login="login"
				@setregdraw="setReg"
				:mobile="true"
				:sourceType="sourceType">
			</login>
		</div>
	</div>
</template>

<script>
import TopNav from '@/components/topNav/index'
import login from '@/components/login/index'
import _ from '@/utils/util'
import { mapGetters } from 'vuex'
// import apiDraw from '@/api/draw'

export default {
	name: 'pagehistory',
	components: {
		login,
		TopNav
	},
	computed:{
		...mapGetters([
				'user'
		])
	},
	data () {
		return {
			isMobile:_.isMobile(),
			text: '注册并登录',
			sourceType: _.getQuerys('sourcetype')
		}
	},
	methods: {
		closeConfirm(){
			window.top.postMessage(JSON.stringify({
        op: 'closeConfirm'
      }), '*');
		},
		clear () {
			if (!this.in) {
				this.$store.commit('setReadyplaying', {})
			}
		},
		// 设置是否注册
		setReg (text) {
			this.text = text
		},
		login (reg, res) {
			console.log('是否老用户',reg)
			console.log('登陆成功,token',res)
			this.$toast({
				top: 0,
				type: 'success',
				text: '登录成功'
			})

			setTimeout( ()=>{
				this.$router.replace({path:'/'})
			},3000)

		}
	},
  mounted () {
		document.documentElement.classList.add('bodybg')
  },
  destroyed () {
    document.documentElement.classList.remove('bodybg')
  }
}
</script>
